// extracted by mini-css-extract-plugin
export default {"dashboardCard":"AssessorDashboardPage_dashboardCard__OVJXX"};